import { createFileRoute } from "@tanstack/react-router";
import { VeiledningPage } from "@/features/landing";

export const Route = createFileRoute("/_public/_landing/veiledning")({
  component: VeiledningPage,
  head: () => ({
    meta: [
      {
        title: "Veiledning | Norgespris for Fjernvarme",
      },
    ],
  }),
});
